// extracted by mini-css-extract-plugin
export default {"title":"Tile_title__caUFT","description":"Tile_description__35N7k"};